import { useQueryClient } from "@tanstack/react-query";
import { ButtonVariant, CoButton } from "components/CoButton";
import { MixpanelActionSource } from "helpers/services/mixpanel/events";
import useLabels from "hooks/useLabels";
import { toast } from "react-toastify";
import { useResearchPaperUpload } from "./hooks/useResearchPaperUpload";

/**
 * This component is displayed in the Research Hub when the user has no uploaded papers.
 */
export const ZeroUploadedPapersEducation = () => {
  const [labels] = useLabels("research-hub");
  const [askPaperLabels] = useLabels("ask-paper-upload-new-paper-guide");
  const queryClient = useQueryClient();

  const { triggerFileSelection, isUploading } = useResearchPaperUpload({
    onSuccess: () => {
      toast.success(askPaperLabels["toast-success"]);
    },
    onError: (errorMessage?: string) => {
      toast.error(errorMessage || askPaperLabels["toast-error"]);
    },
    actionSource: MixpanelActionSource.ResearchHubZeroStateEducation,
  });

  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="mb-4">
        <img src="/icons/ask-paper.svg" alt="No results" className="w-8 h-8" />
      </div>
      <h3 className="text-lg font-medium mb-2">{labels["upload-first-pdf"]}</h3>
      <p className="text-fg-muted mb-6 max-w-lg">
        {labels["upload-first-pdf-description"]}
      </p>
      <CoButton
        variant={ButtonVariant.Secondary}
        label={isUploading ? labels["uploading"] : labels["upload-paper"]}
        icon="icon-upload"
        size="sm"
        onClick={triggerFileSelection}
        disabled={isUploading}
      />
    </div>
  );
};

export default ZeroUploadedPapersEducation;
